import React from 'react';
import { Typography, Box } from '@mui/material';
import { Footer } from '../Footer';
import HeroContainer from '../ui/hero-container';
import OrangeButton from '../buttons/orange-button';
import ContactTestimonialCarousel from '../contact/ContactTestimonialCarousel';

import HeaderAlt from '../HeaderAlt';

const BoardOfDirectors = () => {
  const publicUrl = process.env.PUBLIC_URL;
  const partners = [
    {
      name: 'Flexible Tutoring Opportunities',
      logo: publicUrl + '/images/partnership/doran-logo.webp',
      description:
        'Expand your tutoring business or kickstart a new one—whether you’re looking for a full-time career or a flexible way to earn extra income.',
      url: 'https://www.doranandscalora.com/',
    },
    {
      name: 'Start Tutoring with Ease',
      logo: publicUrl + '/images/partnership/doran-logo.webp',
      description:
        'New to tutoring? No problem! Access our comprehensive learning resources and connect with our supportive tutor community to get started with confidence.',
      url: 'https://www.doranandscalora.com/',
    },
    {
      name: 'AI Tools for Better Sessions',
      logo: publicUrl + '/images/partnership/doran-logo.webp',
      description:
        'Leverage our unique AI tools to generate customized lesson plans, practice problems, and more—ensuring you’re fully prepared for a productive session, every time.',
      url: 'https://www.doranandscalora.com/',
    },
    {
      name: 'Organize with Smart Dashboard',
      logo: publicUrl + '/images/partnership/doran-logo.webp',
      description:
        'Leverage our unique AI tools to generate customized lesson plans, practice problems, and more—ensuring you’re fully prepared for a productive session, every time.',
      url: 'https://www.doranandscalora.com/',
    },
  ];

  return (
    <div className="flex-container">
      <HeaderAlt />
      <HeroContainer className="landing-section !pb-12">
        <p className="tagline fredoka ">🤝 Support our mission</p>
        <h1 className="headline hero-title !max-w-[866px] !font-semibold">
          Our Board of <br />
          Directors
        </h1>
        <p className="description !max-w-[720px]">
          We are redefining the way students learn and giving them tools of the future to make
          learning enjoyable, affordable and accessible
        </p>
        <div className="button-container">
          <div className="box-border hidden h-1/2 w-[189px] rounded-[16px] bg-[#FC823E] py-[10px] text-center font-medium text-white shadow-[0px_1px_2px_0px_rgba(255,255,255,0.40)inset,0px_4px_4px_0px_rgba(255,255,255,0.35)inset] lg:flex">
            <a href="#invest" className="w-full px-4">
              C5ntact Us
            </a>
          </div>
        </div>
      </HeroContainer>

      <h2 className="fredoka mb-6 mt-12 text-center text-4xl font-semibold leading-[1.5] text-teal-900">
        Why partner with IAMAI
      </h2>
      <div className="container grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-4">
        {partners.map((partner, index) => (
          <div className="flex justify-center" key={index}>
            <div
              className="max-w-sm rounded-3xl shadow"
              style={{
                background: 'linear-gradient(136deg, #FFF 8.91%, #F7F7F7 50%)',
                display: 'flex',
                flexDirection: 'column', // Ensure the content stacks vertically
                justifyContent: 'space-between', // Make sure content is spaced out evenly
              }}
            >
              <a href={partner.url} target="_blank" rel="noopener noreferrer">
                <img src={partner.logo} alt={partner.name} className="mx-auto mt-4 h-36 w-auto" />
              </a>
              <div className="flex flex-grow flex-col justify-between p-4">
                {' '}
                {/* Flexbox for content */}
                <h5 className="font-[Fredoka] text-[22px] font-medium leading-normal tracking-[-0.64px] text-[#012E33]">
                  {partner.name}
                </h5>
                <p className="font-[Fredoka] text-[16px] font-normal leading-[26px] tracking-[-0.36px] text-[#678285]">
                  {partner.description}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="-mt-4 lg:!-mt-24">
        <ContactTestimonialCarousel />
      </div>
      <div id="invest">
        <Box className="mt-7 bg-[#E0F5F5]" sx={{ textAlign: 'center', py: 7 }}>
          <Typography
            className="description !mx-auto !text-[32px] !text-[#012E33] lg:!text-[42px]"
            variant="h4"
            gutterBottom
          >
            Invest in us
          </Typography>
          <p className="description !mx-auto !max-w-[446px] !px-4 text-center !text-lg lg:!text-[22px]">
            Interested in becoming a partner? <br />
            Send us a message using the form below.
          </p>
          <div className="mx-auto mt-12 max-w-[623px]">
            <div className=" mt-5 space-y-8 rounded-[24px] px-4 ">
              <form className="space-y-7">
                <div className="space-y-2">
                  <label className="ml-1 flex font-[Fredoka] text-[20px] font-normal leading-[30px] text-[#012E33] ">
                    First Name*
                  </label>
                  <input
                    type="text"
                    placeholder="Enter your First Name"
                    className="w-full rounded-[16px] border border-[#DCDCDC] bg-white px-3 py-5 font-[Fredoka] text-[16px] font-normal leading-normal tracking-[-0.16px] text-[#678285] focus:outline-none focus:ring-2"
                  />
                </div>

                <div className="space-y-2">
                  <label className="ml-1 flex font-[Fredoka] text-[20px] font-normal leading-[30px] text-[#012E33]">
                    Last Name*
                  </label>
                  <input
                    type="text"
                    placeholder="Enter your Last Name"
                    className="w-full rounded-[16px] border border-[#DCDCDC] bg-white px-3 py-5 font-[Fredoka] text-[16px] font-normal leading-normal tracking-[-0.16px] text-[#678285] focus:outline-none focus:ring-2"
                  />
                </div>

                <div className="space-y-2">
                  <label className="ml-1 flex font-[Fredoka] text-[20px] font-normal leading-[30px] text-[#012E33]">
                    Email*
                  </label>
                  <input
                    type="email"
                    placeholder="Enter your Email"
                    className="w-full rounded-[16px] border border-[#DCDCDC] bg-white px-3 py-5 font-[Fredoka] text-[16px] font-normal leading-normal tracking-[-0.16px] text-[#678285] focus:outline-none focus:ring-2"
                  />
                </div>

                <div className="space-y-2">
                  <label className="ml-1 flex font-[Fredoka] text-[20px] font-normal leading-[30px] text-[#012E33]">
                    Company/Organization Name*
                  </label>
                  <input
                    type="text"
                    placeholder="Enter your Company/Organization Name"
                    className="w-full rounded-[16px] border border-[#DCDCDC] bg-white px-3 py-5 font-[Fredoka] text-[16px] font-normal leading-normal tracking-[-0.16px] text-[#678285] focus:outline-none focus:ring-2"
                  />
                </div>

                <div className="space-y-2">
                  <label className="ml- ml-1 flex font-[Fredoka] text-[20px] font-normal leading-[30px] text-[#012E33]">
                    How would you like to partner?
                  </label>
                  <textarea
                    rows="4"
                    placeholder="Write a message"
                    className="w-full rounded-[16px] border border-[#DCDCDC] bg-white px-3 py-5 font-[Fredoka] text-[16px] font-normal leading-normal tracking-[-0.16px] text-[#678285] focus:outline-none focus:ring-2"
                  ></textarea>
                </div>

                <div className="flex w-full justify-center">
                  <OrangeButton cl5ssName="!w-[189px]" label={'Submit'} />
                </div>
              </form>
            </div>
          </div>
        </Box>
      </div>

      <Footer />
    </div>
  );
};

export default BoardOfDirectors;
